import React from "react";
import { Link } from "react-router-dom";
import { formatCoords } from "@/lib/avenza.js";

export function PhotoLightbox({ items, index, onClose, onIndex, ui }) {
  const photo = items[index];
  if (!photo) return null;
  const hasGps = photo.latitude != null && photo.longitude != null;
  return (
    <div className="og-lightbox" data-testid="photo-viewer" role="dialog" aria-modal="true">
      <div className="og-lightbox__bar">
        <strong>{photo.caption || photo.original_filename || ui.photos.title}</strong>
        <button type="button" className="og-btn og-btn--ghost" onClick={onClose}>{ui.app.close}</button>
      </div>
      {photo.url ? <img src={photo.url} alt={photo.caption || photo.original_filename || ""} /> : <p className="og-hint">{ui.photos.empty}</p>}
      <div className="og-lightbox__bar">
        <button type="button" className="og-btn" disabled={index <= 0} onClick={() => onIndex(index - 1)}>{ui.app.prev}</button>
        <p>
          {photo.comment || ""}
          {hasGps ? ` · ${formatCoords(photo.latitude, photo.longitude)}` : ""}
        </p>
        {hasGps ? <Link className="og-btn" to="/territoire/carte">{ui.territory.openMap}</Link> : <span />}
        <button type="button" className="og-btn" disabled={index >= items.length - 1} onClick={() => onIndex(index + 1)}>{ui.app.next}</button>
      </div>
    </div>
  );
}
